// extracted by mini-css-extract-plugin
module.exports = {"card":"Dashboard_card__3Z0-9","courseName":"Dashboard_courseName__REjf5"};